import { useEffect, useMemo, useRef, useState } from 'react';
import { entidadeTheme } from '../entidadeTheme';
import { getPessoaImageSet } from '../../utils/images';
import { buildThemeFromLogo } from './buildThemeFromLogo';

const getLogoUrlFromPessoaId = logoPessoaId => {
  if (!logoPessoaId) return '';

  const imageSet = getPessoaImageSet(logoPessoaId);
  const srcSet = imageSet?.[0]?.srcSet || '';
  const firstSource = srcSet.split(',')[0] || '';
  return firstSource.trim().split(' ')[0] || '';
};

export const useDynamicEntidadeTheme = logoPessoaId => {
  const [theme, setTheme] = useState(entidadeTheme);
  const requestIdRef = useRef(0);
  const isDev = process.env.NODE_ENV !== 'production';

  const logoUrl = useMemo(() => getLogoUrlFromPessoaId(logoPessoaId), [logoPessoaId]);

  useEffect(() => {
    let mounted = true;
    requestIdRef.current += 1;
    const requestId = requestIdRef.current;

    if (!logoUrl) {
      if (isDev) {
        console.warn('[dynamic-theme] skipped: empty logo url', {
          logoPessoaId,
          staticAssetsUri: process.env.REACT_APP_STATIC_ASSETS_URI
        });
      }
      setTheme(entidadeTheme);
      return () => {
        mounted = false;
      };
    }

    if (isDev) {
      console.info('[dynamic-theme] building theme from logo', { logoUrl, logoPessoaId });
    }

    buildThemeFromLogo({ logoUrl, fallbackTheme: entidadeTheme }).then(nextTheme => {
      if (!mounted || requestId !== requestIdRef.current) return;
      setTheme(nextTheme);
    });

    return () => {
      mounted = false;
    };
  }, [isDev, logoPessoaId, logoUrl]);

  return theme;
};

export default useDynamicEntidadeTheme;
